/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleUp: {
  name: 'chevrons-double-up';
  data: string;
} = {
  name: 'chevrons-double-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.354 7.354a.5.5 0 1 1-.708-.708l4-4a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708L8 3.707 4.354 7.354Zm0 6a.5.5 0 0 1-.708-.708l4-4a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708L8 9.707l-3.646 3.647Z" fill="currentColor"/></svg>`,
};
